import { render, staticRenderFns } from "./WipWeekPlan.vue?vue&type=template&id=225c8d7a&"
import script from "./WipWeekPlan.vue?vue&type=script&lang=js&"
export * from "./WipWeekPlan.vue?vue&type=script&lang=js&"
import style0 from "./WipWeekPlan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports